import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admissions',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class AdmissionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
